// 'use client';
import { addEventParam, INinjaEvent, useQueuedEventStore } from '@ninjacart/nc-events-sdk-v2';
import {
  handleMarketingEvents,
  KissanEventType,
  useGlobalLoginContext,
  useHomeContext,
  useProfileStore,
} from '@ninjacart/nc-nk-store';
import {
  HomePlaceHolder,
  HomeScreenMic,
  isWeb,
  ModeratorFloatButtonComponent,
  useTheme,
  YStack,
  Text,
} from '@ninjacart/nc-nk-ui';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Platform } from 'react-native';
import { CommentsBottomSheetWrapper } from '../../comments';
import { useHome } from '../hooks/useHome';
import { useHomeAnalytics } from '../hooks/useHomeAnalytics';
import { useLocationPerm } from '../hooks/useLocationPerm';
import { FeedList } from './feedList';
// import { PWAInstallPrompt } from '@ninjacart/nc-nk-adaptive-cards';

export const HomeFeed = ({ initialData }: { initialData?: any }) => {
  const contextFields = [
    'feedItem',
    'isCommentSheetOpen',
    'isReportSheetOpen',
    'activeVideoFeedIndex',
    'headerOffset',
    'isViewableConfigEnabled',
  ];
  const theme = useTheme();
  const homeContext = useHomeContext(contextFields);
  // const setFeedItem = homeContext.feedItem.set;
  const isCommentSheetOpen = homeContext.isCommentSheetOpen.get;
  // const setIsReportSheetOpen = homeContext.isReportSheetOpen.set;
  const setIsCommentSheetOpen = homeContext.isCommentSheetOpen.set;
  const {
    homeFeedsCard,
    loading,
    refreshing,
    onEndReachedSpinner,
    headerHeight,
    isWeatherWidgetAvailable,
    globalSearchEnabled,
    // headerStyles,
    onRefresh,
    onEndReached,
    // scrollHandler,
    locationPermissionAsk,
    weatherLocationPermissionAsk,
    setHomeFeedsCard,
    setExtraData,
    extraData,
    flashListRef,
    cropPreference,
    animalPreference,
    layout,
    setLayout,
  } = useHome({ initialData });

  const { handleSearch, navigateToModeration } = useHomeAnalytics();
  const { userRoles, enableGlobalProfileTabMic } = useLocationPerm();
  const hasUserLoggedIn = useProfileStore((state) => state.hasUserLoggedIn);
  const enqueue = useRef(useQueuedEventStore((state) => state.enqueue)).current;
  const fields = useGlobalLoginContext(['openLoginSheet','previousPage', 'navigationParams']);
  const setNavigationParams = fields.navigationParams.set;
  const { t } = useTranslation();
  const videoIdRef = useRef<string>();
  const postOwnerIdRef = useRef<string>();
  const descriptionRef = useRef<string>();
  // const pwaItem = homeFeedsCard.filter((item) => item.type === 'pwa');
  // const pwaContent = pwaItem[0]?.actionData?.content;
  // const [showPwaPrompt, setShowPwaPrompt] = useState(false);
  const onCommentBottomSheetOpen = async (item, index) => {
    const additionalDetails = [
      addEventParam('itemId', item?.id),
      addEventParam('videoId', item?.id),
      addEventParam('postOwnerId', item?.postOwnerId),
      addEventParam('recommendationId', item?.recommendationId),
    ];
    if (item?.actionData?.content?.rankingId) {
      additionalDetails.push(
        addEventParam('referenceKey4', 'rankingId'),
        addEventParam('referenceValue4', item?.actionData?.content?.rankingId)
      );
    }
    const itemCommentEvent: INinjaEvent = {
      name: KissanEventType.ITEM_COMMENT,
      screenDetails: { screen: 'feed page' },
      eventParams: additionalDetails,
    };
    enqueue(itemCommentEvent);
    handleMarketingEvents(KissanEventType.ITEM_COMMENT, { screen: 'feed page' }, additionalDetails);

    if (!hasUserLoggedIn()) {
      fields['openLoginSheet'].set(true);
      fields['previousPage'].set('FEED PAGE');
      setNavigationParams({
        name: '',
        routeName: {
          name: `longVideo/${Platform.OS == 'web' ? item?.id : 'index'}`,
          params: { id: String(item?.id) },
        },
        description: `${t('page.commentOnHomePage')}`,
        screenName: 'FEED PAGE',
      });
      return;
    }
    setIsCommentSheetOpen(true);
    videoIdRef.current = item?.id;
    postOwnerIdRef.current = item?.postOwnerId;
    descriptionRef.current = item?.description;
  };

  // console.log('Homefeeds length => ', homeFeedsCard.length);
  // useEffect(() => {
  //   if (pwaItem && pwaItem.length > 0) {
  //     setShowPwaPrompt(true);
  //   } else {
  //     setShowPwaPrompt(false);
  //   }
  // }, [pwaItem]);

  // const handleClosePrompt = () => {
  //   setShowPwaPrompt(false);
  // };
  return (
    <YStack
      flex={1}
      backgroundColor={theme?.background?.val}
      onLayout={(e) => {
        setLayout(e.nativeEvent.layout);
        // console.log('🚀 ~ HomeFeed ~ layout:', e.nativeEvent.layout);
      }}
    >
      {/* {showPwaPrompt && pwaContent && (
        <PWAInstallPrompt pwaContent={pwaContent} onClose={handleClosePrompt} />
      )} */}
      {Boolean(homeFeedsCard.length) && (
        <FeedList
          data={homeFeedsCard}
          refreshing={refreshing}
          onRefresh={onRefresh}
          onEndReached={onEndReached}
          onEndReachedSpinner={onEndReachedSpinner}
          onCommentBottomSheetOpen={onCommentBottomSheetOpen}
          // scrollHandler={scrollHandler}
          headerHeight={headerHeight}
          setHomeFeedsCard={setHomeFeedsCard}
          setExtraData={setExtraData}
          extraData={extraData}
          locationPermissionAsk={weatherLocationPermissionAsk}
          isWeatherWidgetAvailable={isWeatherWidgetAvailable}
          flashListRef={flashListRef}
          cropPreference={cropPreference}
          animalPreference={animalPreference}
          // header={
          //   <HomeHeader
          //     isWeatherWidgetAvailable={isWeatherWidgetAvailable}
          //     globalSearchEnabled={globalSearchEnabled}
          //     headerHeight={headerHeight}
          //     // headerStyles={headerStyles}
          //   />
          // }
        />
      )}

      {isCommentSheetOpen && (
        <CommentsBottomSheetWrapper
          id={videoIdRef.current!}
          postOwnerId={postOwnerIdRef.current!}
          description={descriptionRef.current!}
          commentbottomSheet={isCommentSheetOpen}
          setCommentbottomSheet={setIsCommentSheetOpen}
        />
      )}

      {enableGlobalProfileTabMic && <HomeScreenMic handleSearch={handleSearch} />}

      {userRoles && userRoles?.includes('MODERATOR') && (
        <ModeratorFloatButtonComponent navigateToModeration={navigateToModeration} />
      )}
    </YStack>
  );
};
